import React, { useEffect, useState } from "react";
import "./OutOfService.css";

const OutOfService = () => {
 const [requestedPath, setRequestedPath] = useState("");
 
   useEffect(() => {
     setRequestedPath(window.location.pathname || "/restricted");
   }, []);
 
   return (
     <div className="OutOfService-wrap">
       <div className="OutOfService-right">
         <div className="OutOfService-card">
           <div className="OutOfService-card-header">
             <p className="OutOfService-big403">505</p>
             <p className="OutOfService-sub">Page Under Construction</p>
             <div className="OutOfService-meta">MathTounsi · Community Gate</div>
           </div>
 
           <div className="OutOfService-illustration">
             
           </div>
         </div>
       </div>
 
       <div className="OutOfService-left">
         <h1 style={{ color: "#8f0122ff", fontSize: "2.5em" }}>
           MathTounsi — Coming Soon!
         </h1>
         <p>
           This section is temporarily out of service while we grow our community. 
          We want to ensure the best experience for everyone, so we're waiting until 
          we reach a critical mass of users before opening this area.
         </p>
 
         <div className="OutOfService-code">
           Requested: <strong>{requestedPath}</strong>
         </div>
 
         <div className="OutOfService-mathbits" aria-hidden>
           <div className="OutOfService-chip">Community ∝ Resources</div>
           <div className="OutOfService-chip">lim<sub>t→∞</sub> Users = 10k</div>
           <div className="OutOfService-chip">Growth Rate: 23 users/sec</div>
           
         </div>
 
         <div className="OutOfService-actions">
           <button
             className="OutOfService-btn OutOfService-btn-primary"
           >
             Invite Friends
           </button>
           <button
             className="OutOfService-btn OutOfService-btn-muted"
             onClick={() => window.history.back()}
           >
             Go back
           </button>
         </div>
 
         <footer className="OutOfService-footer">
           Tip: Help us grow faster by sharing MathTounsi with your friends and classmates!
         </footer>
       </div>
     </div>
  );
};

export default OutOfService;